import styled from 'styled-components'
import { Typography } from '@telavita-core/react-design-kit'

export const Container = styled.div``

export const ImageWrapper = styled.div`
  margin-bottom: 30px;
  width: 100%;
`

export const Text = styled(Typography)`
  line-height: 20px;
`

export const StyledList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  margin-bottom: 20px;
`

export const StyledListItem = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
`

export const StyledListNumber = styled(Typography)`
  width: 30px;
  height: 27px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1f35b5;
  letter-spacing: 0px;
  color: #ffffff;
`

export const ListItemDescription = styled(Typography)`
  width: 100%;
`

export const MoreInformationText = styled(Typography)``

export const MoreInformationLink = styled.a`
  font-size: 15px;
  font-weight: bold;
  color: #1f35b5;
`
